import { Reveal } from "@/lib/motion";

const pub = (p) => (p ? `${window.location.origin}/api/public/img/${p}` : null);

export default function Gallery({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <section id="galerie" className="border-t border-white/10 py-20 md:py-24" data-testid="section-galerie">
      <div className="mx-auto max-w-6xl px-5">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-korban-gold">Galerie</p>
          <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
            La vie du cabinet en images
          </h2>
          <div className="mt-5 h-1 w-16 rounded-full bg-korban-gold" />
        </Reveal>
        <div className="mt-10 columns-2 gap-4 md:columns-3 lg:columns-4" data-testid="gallery-grid">
          {items.map((it, i) => (
            <Reveal key={it.id} delay={0.05 * (i % 4)} className="mb-4 break-inside-avoid">
              <figure
                className="group overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04]"
                data-testid={`gallery-photo-${it.id}`}
              >
                <img
                  src={pub(it.path)}
                  alt={it.title || "KORBAN CONSULTING"}
                  className="w-full transition-transform duration-500 group-hover:scale-[1.02]"
                  loading="lazy"
                />
                {it.title ? (
                  <figcaption className="px-4 py-3 text-xs font-semibold text-slate-300">{it.title}</figcaption>
                ) : null}
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
